import { render, staticRenderFns } from "./headbox.vue?vue&type=template&id=acf1a84c&scoped=true"
import script from "./headbox.vue?vue&type=script&lang=js"
export * from "./headbox.vue?vue&type=script&lang=js"
import style0 from "./headbox.vue?vue&type=style&index=0&id=acf1a84c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acf1a84c",
  null
  
)

export default component.exports